
import logo from "../components/images/Kenzielearnlogo.png";


export default function Home() {
    return (<div>
      <div>
      <img src={logo} alt="Kenzie Learn logo" width="100px" /><h1>Kenzie Learn</h1>; 
      </div>
      </div>
    )
}